const apiServe = {
    'carouselList': '/index/HomeCarousel/carouselList    ', //首页轮播图列表
    'aboutUsList': '/index/AboutUs/aboutUsList    ', //关于我们
    'businessCategorylist': '/index/BusinessCategory/businessCategorylist    ', //主营业务分类列表
    'CoreBusinesslist': '/index/CoreBusiness/CoreBusinesslist    ', //主营业务列表 
    'offlineForumlist': '/index/OfflineForum/offlineForumlist    ', //线下论坛内容列表 
    'financialForumList': '/index/FinancialForum/financialForumList    ', //金融论坛内容列表

    'activityCategoryList': '/index/ActivityCategory/activityCategoryList    ', //活动分类列表
    'activityList': '/index/Activity/activityList    ', //活动列表
    'register': '/index/ActivityRegistration/register    ', //人员报名

    'aboutUsCategoryList': '/index/AboutUsCategory/aboutUsCategoryList    ', //关于我们分类
    'businessCategorylist': '/index/BusinessCategory/businessCategorylist    ', //主营业务分类列表

    'forumCategorylist': '/index/ForumCategory/forumCategorylist    ', //线下论坛分类列表

    'CoreBusinessDetail': '/index/CoreBusiness/CoreBusinessDetail    ', //主营业务详情信息
    'financialForumDetail': '/index/FinancialForum/financialForumDetail    ', //金融论坛详情信息
    'offlineForumDetail': '/index/OfflineForum/offlineForumDetail    ', //线下论坛详情信息
    'getActivityDetail': '/index/Activity/getActivityDetail    ', //活动报名详情信息

    'financialForumCategoryList': '/index/FinancialForumCategory/financialForumCategoryList    ', //金融论坛分类列表













}



//导出模块对象
export default apiServe
// export { apiServe }
